import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatLocalDate } from '@domains/orchestrator-pricing-committee/utils/dates';

export const DateInterval = ({
  startAt,
  endAt,
  updatedAt,
}: {
  startAt?: string;
  endAt?: string;
  updatedAt?: string;
}) => {
  const fixStartAt = formatLocalDate(startAt);
  const fixEndAt = formatLocalDate(endAt);
  const fixUpdatedAt = formatLocalDate(updatedAt);

  const fullStartAt = formatLocalDate(startAt, true);
  const fullEndAt = formatLocalDate(endAt, true);
  const fullUpdatedAt = formatLocalDate(updatedAt, true);

  const label = endAt ? 'Inició - Terminó' : 'Inició - Última Actualización';
  const endValue = endAt ? fixEndAt : fixUpdatedAt;
  const fullEndValue = endAt ? fullEndAt : fullUpdatedAt;

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip id="tooltip-dates">
          <div>
            Inició: {fullStartAt}
            <br />
            {endAt ? 'Terminó: ' : 'Última Actualización: '}
            {fullEndValue}
          </div>
        </Tooltip>
      }
    >
      <div>
        <div className="fw-bold">{label}</div>
        <div className="d-flex gap-2" style={{ cursor: 'pointer' }}>
          <span>{fixStartAt}</span>
          <span className="fw-bold">-</span>
          <span>{endValue}</span>
        </div>
      </div>
    </OverlayTrigger>
  );
};
